(function (angular) {
    'use strict';

    angular.module('profiles')

        .factory('profileTemplateService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {
                    var urlBase = portalConfig.urlBase;
                    //urlBase = "http://localhost:8002";

                    var fac = {
                        updateProfileTemplate: updateProfileTemplate,
                        getProfileTemplate: getProfileTemplate,
                        getProfileTemplateSchema: getProfileTemplateSchema,
                        allowOtherProperties: allowOtherProperties
                    };

                    return fac;

                    function updateProfileTemplate(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/profiles/template", data)
                            .then(updateProfileTemplateComplete)
                            .catch(updateProfileTemplateFailed);

                        function updateProfileTemplateComplete(response) {
                            return response.data;
                        }

                        function updateProfileTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getProfileTemplate(id, async) {

                        return $http.get(urlBase + "/apispaces/" + id + "/profiles/template", { async: async })
                            .then(getProfileTemplateComplete)
                            .catch(getProfileTemplateFailed);

                        function getProfileTemplateComplete(response) {
                            return response.data;
                        }

                        function getProfileTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getProfileTemplateSchema(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/profiles/template/schema")
                            .then(getProfileTemplateComplete)
                            .catch(getProfileTemplateFailed);

                        function getProfileTemplateComplete(response) {
                            return response.data;
                        }

                        function getProfileTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/profiles"
                     * @param {string} id - the api space Id
                     */
                    function allowOtherProperties(id, allowOtherProperties) {

                        return $http.put(urlBase + "/apispaces/" + id + "/profiles/template/allowotherproperties", { allowOtherProperties: allowOtherProperties })
                            .then(allowOtherPropertiesComplete)
                            .catch(allowOtherPropertiesFailed);

                        function allowOtherPropertiesComplete(response) {
                            return response.data;
                        }

                        function allowOtherPropertiesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);